// Не забудь обновить фронт.
// @see resources/assets/js/models/FF14Model.js -> FF14ServerModel
const FF14ServerModel = [
  {
    id: 69,
    title: 'Alpha',
  },
  {
    id: 2,
    title: 'Aegis',
  },
  {
    id: 1,
    title: 'Adamantoise',
  },
  {
    id: 3,
    title: 'Alexander',
  },
  {
    id: 4,
    title: 'Anima',
  },
  {
    id: 5,
    title: 'Asura',
  },
  {
    id: 6,
    title: 'Atomos',
  },
  {
    id: 70,
    title: 'Bismarck',
  },
  {
    id: 7,
    title: 'Bahamut',
  },
  {
    id: 8,
    title: 'Balmung',
  },
  {
    id: 10,
    title: 'Belias',
  },
  {
    id: 9,
    title: 'Behemoth',
  },
  {
    id: 11,
    title: 'Brynhildr',
  },
  {
    id: 12,
    title: 'Cactuar',
  },
  {
    id: 13,
    title: 'Carbuncle',
  },
  {
    id: 71,
    title: 'Cuchulainn',
  },
  {
    id: 14,
    title: 'Cerberus',
  },
  {
    id: 15,
    title: 'Chocobo',
  },
  {
    id: 16,
    title: 'Coeurl',
  },
  {
    id: 17,
    title: 'Diabolos',
  },
  {
    id: 18,
    title: 'Durandal',
  },
  {
    id: 19,
    title: 'Excalibur',
  },
  {
    id: 20,
    title: 'Exodus',
  },
  {
    id: 21,
    title: 'Faerie',
  },
  {
    id: 22,
    title: 'Famfrit',
  },
  {
    id: 23,
    title: 'Fenrir',
  },
  {
    id: 24,
    title: 'Garuda',
  },
  {
    id: 86,
    title: 'Halicarnassus',
  },
  {
    id: 25,
    title: 'Gilgamesh',
  },
  {
    id: 26,
    title: 'Goblin',
  },
  {
    id: 72,
    title: 'Golem',
  },
  {
    id: 27,
    title: 'Gungnir',
  },
  {
    id: 28,
    title: 'Hades',
  },
  {
    id: 29,
    title: 'Hyperion',
  },
  {
    id: 30,
    title: 'Ifrit',
  },
  {
    id: 31,
    title: 'Ixion',
  },
  {
    id: 32,
    title: 'Jenova',
  },
  {
    id: 33,
    title: 'Kujata',
  },
  {
    id: 34,
    title: 'Lamia',
  },
  {
    id: 35,
    title: 'Leviathan',
  },
  {
    id: 36,
    title: 'Lich',
  },
  {
    id: 37,
    title: 'Louisoix',
  },
  {
    id: 38,
    title: 'Malboro',
  },
  {
    id: 73,
    title: 'Innocence',
  },
  {
    id: 39,
    title: 'Mandragora',
  },
  {
    id: 40,
    title: 'Masamune',
  },
  {
    id: 41,
    title: 'Mateus',
  },
  {
    id: 74,
    title: 'Kraken',
  },
  {
    id: 42,
    title: 'Midgardsormr',
  },
  {
    id: 43,
    title: 'Moogle',
  },
  {
    id: 87,
    title: 'Maduin',
  },
  {
    id: 88,
    title: 'Marilith',
  },
  {
    id: 44,
    title: 'Odin',
  },
  {
    id: 45,
    title: 'Omega',
  },
  {
    id: 75,
    title: 'Phantom',
  },
  {
    id: 46,
    title: 'Pandaemonium',
  },
  {
    id: 47,
    title: 'Phoenix',
  },
  {
    id: 76,
    title: 'Pixie',
  },
  {
    id: 48,
    title: 'Ragnarok',
  },
  {
    id: 49,
    title: 'Ramuh',
  },
  {
    id: 50,
    title: 'Ridill',
  },
  {
    id: 77,
    title: 'Rafflesia',
  },
  {
    id: 78,
    title: 'Raiden',
  },
  {
    id: 79,
    title: 'Ravana',
  },
  {
    id: 51,
    title: 'Sargatanas',
  },
  {
    id: 80,
    title: 'Sagittarius',
  },
  {
    id: 81,
    title: 'Sephirot',
  },
  {
    id: 82,
    title: 'Sophia',
  },
  {
    id: 89,
    title: 'Seraph',
  },
  {
    id: 52,
    title: 'Shinryu',
  },
  {
    id: 53,
    title: 'Shiva',
  },
  {
    id: 54,
    title: 'Siren',
  },
  {
    id: 55,
    title: 'Spriggan',
  },
  {
    id: 56,
    title: 'Tiamat',
  },
  {
    id: 57,
    title: 'Titan',
  },
  {
    id: 83,
    title: 'Titania',
  },
  {
    id: 58,
    title: 'Tonberry',
  },
  {
    id: 59,
    title: 'Twintania',
  },
  {
    id: 60,
    title: 'Typhon',
  },
  {
    id: 84,
    title: 'Tycoon',
  },
  {
    id: 61,
    title: 'Ultima',
  },
  {
    id: 62,
    title: 'Ultros',
  },
  {
    id: 63,
    title: 'Unicorn',
  },
  {
    id: 64,
    title: 'Valefor',
  },
  {
    id: 85,
    title: 'Zurvan',
  },
  {
    id: 65,
    title: 'Yojimbo',
  },
  {
    id: 66,
    title: 'Zalera',
  },
  {
    id: 67,
    title: 'Zeromus',
  },
  {
    id: 68,
    title: 'Zodiark',
  },
];

// eslint-disable-next-line import/prefer-default-export
export { FF14ServerModel };
